import ClassBreaksRenderer from '@arcgis/core/renderers/ClassBreaksRenderer';
import SimpleMarkerSymbol from '@arcgis/core/symbols/SimpleMarkerSymbol';
import Color from '@arcgis/core/Color';
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

import LabelClass from "@arcgis/core/layers/support/LabelClass";
import { getTextColor } from 'src/store/common';
import PopupTemplate from '@arcgis/core/PopupTemplate';
import Graphic from '@arcgis/core/Graphic';
import Point from '@arcgis/core/geometry/Point';
import SpatialReference from '@arcgis/core/geometry/SpatialReference';

const snowflagNumeric = (value: any) => {
    if (value === 'Y') {
        return 0
    }
    else if (value === 'N') {
        return 1
    }
    else {
        return -2000
    }
};

export const returnValue = (value: any, type: string) => {
    if (type === 'snow_flag') {
        return snowflagNumeric(value);
    }
    else if (value === null) {
        return -2000
    } else {
        return value;
    }
    
};

const popupTemplate = new PopupTemplate({
    title: "{id}",
    content: "<div id='custompoop' key='custompoop' class='custompoop' style='padding: 10px'>{name}</div>",

    outFields: ["{id}"],
    fieldInfos: [
        {fieldName: 'id', visible: false},
        {fieldName: 'name', visible: false},
        {fieldName: 'network', visible: false},
        {fieldName: 'state', visible: false},
    ]
});

/* test feature layer this is where to test to see how to add a layer*/
export const formatDataToLayer = (data: any[], element: any, zoom: number, startDate: any, endDate: any, radio: any) => {
    const obs = data.filter(item => item.observation_type === 'O');
    const forecasts = data.filter(item => item.observation_type === 'F');

    /*below is a geojson layer for observations*/
    const obsGraphics = obs.map((item) =>
        new Graphic({
            geometry: new Point({
                latitude: item.latitude,
                longitude: item.longitude,
                spatialReference: new SpatialReference({ wkid: 4326 })
            }),
            attributes: {
                name: item.station_name,
                id: item.station_id,
                type: item.observation_type,
                value: returnValue(item[element.value], element.value),
                label: item[element.value] !== null ? item[element.value]?.toString() : "●●●",
                elevation: item.elevation,
                network: item.network_name,
                state: item.state,
                has_historic_data: (item.has_historic_data).toString().toLowerCase()==='true'?1:0
            }

        })
    );
    const obsFeatureLayer = new FeatureLayer({
        source: obsGraphics,
        objectIdField: 'ObjectId',
        popupTemplate: popupTemplate,
        editingEnabled: true,
        id: `observation&Element=${radio}&Value=${element.value}&Zoom=${zoom}&StartDate=${startDate}&EndDate=${endDate}`,
        fields: [
            {
                name: "ObjectId",
                type: 'oid'
            },
            {
                name: "value",
                type: "double"
            },
            {
                name: "name",
                type: "string"
            },
            {
                name: "id",
                type: "integer"
            },
            {
                name: "type",
                type: "string"
            },
            {
                name: "label",
                type: "string"
            },
            {
                name: "elevation",
                type: "integer"
            },
            {
                name: "network",
                type: "string"
            },
            {
                name: "state",
                type: "string"
            },
            {
                name: "has_historic_data",
                type: "integer"
            },
        ],
        geometryType: "point",
        outFields: ["ObjectID", "name", "id", "state", "network", "has_historic_data"]

    })
    const observationRenderer = new ClassBreaksRenderer({
        field: "value",
        classBreakInfos: element.colors.map((color: any) => ({
            minValue: color.minValue,
            maxValue: color.maxValue,
            symbol: new SimpleMarkerSymbol({
                color: new Color(color.rgb),
                size: "32px",
                outline: {
                    color: color.minValue === -2000 ? 'red' : 'grey',
                    width: color.minValue === -2000 ? 2 : 1
                }
            }),
            label: "id"
        }))
    });


    /*below is a geojson layer for forecasts*/
    const featuresfore = forecasts.map((item) =>
        new Graphic({
            geometry: new Point({
                latitude: item.latitude,
                longitude: item.longitude,
                spatialReference: new SpatialReference({ wkid: 4326 })
            }),
            attributes: {
                name: item.station_name,
                id: item.station_id,
                type: item.observation_type,
                value: returnValue(item[element.value], element.value),
                label: item[element.value] !== null ? item[element.value]?.toString() : "●●●",
                elevation: item.elevation,
                network: item.network_name,
                state: item.state,
                has_historic_data: (item.has_historic_data).toString().toLowerCase()==='true'?1:0

            }
        })
    );


    const foreFeatureLayer = new FeatureLayer({
        source: featuresfore,
        objectIdField: 'ObjectId',
        popupTemplate: popupTemplate,
        editingEnabled: true,
        id: `forecastValues&Element=${radio}&Value=${element.value}&Zoom=${zoom}&StartDate=${startDate}&EndDate=${endDate}`,
        fields: [
            {
                name: "ObjectId",
                type: 'oid'
            },
            {
                name: "value",
                type: "double"
            },
            {
                name: "name",
                type: "string"
            },
            {
                name: "id",
                type: "integer"
            },
            {
                name: "type",
                type: "string"
            },
            {
                name: "label",
                type: "string"
            },
            {
                name: "elevation",
                type: "integer"
            },            
            {
                name: "network",
                type: "string"
            },
            {
                name: "state",
                type: "string"
            },
            {
                name: "has_historic_data",
                type: "integer"
            },
        ],
        geometryType: "point",
        outFields: ["ObjectID", "name", "id", "state", "network", "has_historic_data"]
    })
    const forecastRenderer = new ClassBreaksRenderer({
        field: "value",
        classBreakInfos: element.colors.map((color: any) => ({
            minValue: color.minValue,
            maxValue: color.maxValue,
            symbol: new SimpleMarkerSymbol({
                style: "diamond",
                color: new Color(color.rgb),
                size: "38px",
                outline: {
                    color: color.minValue === -2000 ? 'red' : 'grey',
                    width: color.minValue === -2000 ? 2 : 1,
                }
            }),
            label: color.value
        }))
    });

    const labelingInfo = observationRenderer.classBreakInfos.map(classBreak => new LabelClass({
        labelExpressionInfo: { expression: "$feature.label" },
        symbol: {
            type: "text",
            color: getTextColor(classBreak.symbol.color),
            font: {
                size: "12px",
            }
        },
        deconflictionStrategy: "none",
        labelPlacement: "center-center",
        where: `value >= ${classBreak.minValue} AND value <= ${classBreak.maxValue}`
    })
    );

    obsFeatureLayer.renderer = observationRenderer;
    obsFeatureLayer.labelsVisible = true;
    obsFeatureLayer.labelingInfo = labelingInfo;

    foreFeatureLayer.renderer = forecastRenderer;
    foreFeatureLayer.labelsVisible = true;
    foreFeatureLayer.labelingInfo = labelingInfo;

    return { obsLayer: obsFeatureLayer, forecastLayer: foreFeatureLayer};
};